import { bootstrapApplication } from '@angular/platform-browser'

import * as Sentry from '@sentry/angular'

import { isbot } from 'isbot'

import { AppComponent } from '@app/app.component'
import { appConfig } from '@app/app.config'
import { isBridgeRequest, runBridge } from '@app/auth/msal-redirect-bridge'

Sentry.init({
  enabled: !!window.env?.SENTRY_DSN && !isbot(navigator.userAgent),
  dsn: window.env?.SENTRY_DSN,
  environment: window.env?.SENTRY_ENVIRONMENT,
  release: window.env?.ACTED_FRONT_COMMIT_SHA,
  // Leaving dataCollection unset collects user info (IP address), cookies, full headers and bodies since v11:
  // keep the restrictive v10 baseline. The user is still sent explicitly by GlobalErrorInterceptor.
  dataCollection: {
    userInfo: false,
    cookies: false,
    httpHeaders: {
      request: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
      response: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
    },
    httpBodies: [],
    urlQueryParams: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
    genAI: { inputs: false, outputs: false },
    databaseQueryData: false,
    queues: false,
    graphQL: { document: false, variables: false },
  },

  // A synthetic stack trace on captureMessage would regroup the MSAL telemetry issue (actedparis/acted-core#252)
  // and mark each session as errored
  attachStacktrace: false,

  // Adds sentry-trace and baggage headers to backend requests, so a frontend error and the backend error it
  // triggered share a trace id and show up linked in Sentry
  integrations: [Sentry.browserTracingIntegration()],

  // Trace propagation only: no span is sent, so no performance quota is used
  tracesSampleRate: 0,

  tracePropagationTargets: [window.env?.API_BACKEND_URL],
})

// The authorization server is handing back a response on the bridge path, so hand it to the main frame
// instead of starting the app. Skipping the bootstrap is the point: it keeps the service worker, the MSAL
// client, the permissions request, the sidebar build and AppComponent's own handleRedirectObservable out of
// the hidden iframe, and out of the 10s the library allows the bridge to answer in.
if (isBridgeRequest(window.location)) {
  void runBridge()
} else {
  bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err))
}
